import { render, staticRenderFns } from "./PhoneNumberSettings.vue?vue&type=template&id=5fe06c1a&"
import script from "./PhoneNumberSettings.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports